module.exports = __webpack_public_path__ + "static/img/6.abb07c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/sp/6.png
// module id = 8a3u
// module chunks = 0